import { FC } from "react";
import styles from './index.module.less';
import Title from '../../common/title';
import LinkItem from './LinkItem';
import linkgb1 from '../../assets/bg1.png';
import linkgb2 from '../../assets/bg2.png';
import { official, management } from "../../config";

const Index: FC = (props) => {

    return (
        <div style={{height: props.height, width: props.width}} className={styles.body}>
            <Title title='快捷通道'></Title>
            <div className={styles.content}>
                <LinkItem url={official} backImage={linkgb1} text='北京航空航天大学'></LinkItem>
                <LinkItem url={management} backImage={linkgb2} text='资产与实验室管理处'></LinkItem>
            </div>
        </div>
    );
}

export default Index;